var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"loading":_vm.loading}},[(_vm.item.title)?_c('Institutional',{attrs:{"title":_vm.item.title,"text":_vm.item.text,"images":_vm.images}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }